import { Widget } from "../types";

export const ALLOW_INSIGHTS_GENERATION_WIDGETS: Widget["type"][] = ["chart", "table", "ticker", "consumer-data", "competitor-table", "top-offers"];

export const ALLOW_EDIT_WIDGETS: Widget["type"][] = ["chart", "table", "ticker"];
